import { trackGTMEvent } from 'src/helpers/gtm/gtmEvents';
import { Company } from '@typeRoots/common/company';

export const trackCompanyGTMEvent = (company: Company, accountType: string) => {
  if (company.id === 0) {
    // New company creation
    trackGTMEvent(
      'company-details-page-landed',
      {
        screenName: 'CompanyDetailsScreen',
        userEvent: 'User landed on create company details screen',
        eventType: 'create',
      },
      accountType,
    );
  } else {
    // Existing company editing
    trackGTMEvent(
      'company-details-page-landed',
      {
        screenName: 'CompanyDetailsScreen',
        userEvent: 'User landed on edit company details screen',
        companyId: company?.id,
        eventType: 'edit',
      },
      accountType,
    );
  }
};
